/**
 * The Generate control's words in one place — the button and the tutorial's
 * chapter 5 read the same constants, so the tour can never promise
 * something the real control does not say.
 * For Media Devoted | Created By Ciro Autiero
 */
export const GENERATE_LABEL = 'Generate now';
export const GENERATE_CONFIRM_TITLE = "Generate today's drafts?";
export const GENERATE_CONFIRM_LABEL = 'Generate';
export const GENERATE_DRAFTS_ONLY = 'Creates DRAFTs only — nothing sends.';
export const GENERATE_YOU_SEND = 'Nothing sends — you do.';
export const GENERATE_TOOLTIP =
  "Lays out today's plan as DRAFT drops — nothing sends, you do. Safe to re-click: it re-syncs the same day.";
/** Phase 9 (Phase 20: per campaign group) — the groups with Auto-send on
 *  send their drafts at their time; a person sends the rest. */
export const GENERATE_AUTO_SENDS =
  'Campaign groups with Auto-send on send their drafts at the planned time; you send the rest.';
export const GENERATE_TOOLTIP_AUTO =
  "Lays out today's plan as DRAFT drops — campaign groups with Auto-send on send theirs at the planned time, you send the rest. Safe to re-click: it re-syncs the same day.";
export const GENERATE_FILL_LABEL = 'Also fill texts & senders in the background';
export const GENERATE_FILLING_NOTE = 'texts filling in the background';

/** The success toast's title for a generate report. */
export const generateSuccessTitle = (created: number, updated: number): string =>
  created > 0
    ? `${created} drafts created`
    : updated > 0
      ? 'Day re-synced — drafts match the plan'
      : 'Nothing to generate';
